// **** Library Imports *****

import { Route, Routes } from "react-router-dom";

import RootLayout from "@/app/layout";

import PublicRoutes from "./public-routes";
import AdminRoutes from "./admin-routes";
import EmployeeRoutes from "./employee-routes";
import SuperAdminRoutes from "./superadmin-routes";
import TeamLeaderRoutes from "./teamleader-routes";

const WebRoutes = () => {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route path="/*" element={<PublicRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/employee/*" element={<EmployeeRoutes />} />
        <Route path="/superadmin/*" element={<SuperAdminRoutes />} />
        <Route path="/teamleader/*" element={<TeamLeaderRoutes />} />
      </Route>
    </Routes>
  );
};

export default WebRoutes;
